import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const UpdateEnrollmentFeeMutation = graphql.persisted(
  "UpdateEnrollmentFee",
  graphql(`
    mutation UpdateEnrollmentFee($input: UpdateEnrollmentFeeInput!) {
      updateEnrollmentFee(input: $input) {
        enrollmentFee {
          name
          description
          amountCents
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { UpdateEnrollmentFeeMutation };

export function useUpdateEnrollmentFee() {
  return useMutation(UpdateEnrollmentFeeMutation);
}
